module.exports = __webpack_public_path__ + "img/appreciate.6c6d37f2.gif";